import { useEffect, useLayoutEffect, useRef } from "react";

//THIS COMPONENT PROVIDES THE AUDIO FUNCTION IN THE PAGE
//AND MECHANISM TO PLAY/STOP MUSIC BASED ON URL CHANGES
//THAT ARE CONTROLLED BY THE MASTER COMPONENT

function AudioPassivePlayer({
  songUrl,
  songStart,
  handlePause,
  onEnded,
  type,
  volume,
  onTimeUpdate,
  currentTime,
  seekTo,
  isWebPlayer = false, // Nuova prop per disabilitare il limite di 30 secondi
}) {
  const audioRef = useRef(null);

  useLayoutEffect(() => {
    if (songUrl !== "") {
      audioRef.current.currentTime = songStart;
    }
  }, [songUrl]);

  useEffect(() => {
    // checks every second if we have overtaken 30 seconds from songStart
    // ONLY if isWebPlayer is false (preview mode)
    if (isWebPlayer) return; // Skip this check if playing full song

    const intervalId = setInterval(() => {
      if (songUrl !== "") {
        if (!audioRef.current.paused) {
          if (audioRef.current.currentTime > songStart + 30) {
            handlePause();
          }
        }
      }
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, [songUrl, isWebPlayer, songStart, handlePause]);

  useEffect(() => {
    // Set the volume when the 'volume' prop changes
    if (audioRef.current) {
      const volumeValue = (volume / 100) * (65 / 100); //100% is the 65% of the (pc) device
      if (!isNaN(volumeValue) && isFinite(volumeValue)) {
        audioRef.current.volume = volumeValue;
      }
    }
  }, [volume]);

  // Handle time updates
  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const handleTimeUpdate = () => {
      if (onTimeUpdate) {
        onTimeUpdate(audio.currentTime, audio.duration);
      }
    };

    audio.addEventListener("timeupdate", handleTimeUpdate);
    return () => audio.removeEventListener("timeupdate", handleTimeUpdate);
  }, [onTimeUpdate]);

  // Handle seeking
  useEffect(() => {
    if (audioRef.current && seekTo !== null && seekTo !== undefined) {
      audioRef.current.currentTime = seekTo;
    }
  }, [seekTo]);

  return (
    <audio
      ref={audioRef}
      src={songUrl}
      type="audio/mp3"
      autoPlay={true} //needed to play when url is changed and so audio tag re-renders
      id={type}
      onEnded={onEnded}
    />
  );
}

export default AudioPassivePlayer;
